import { Routes, Route, Navigate, useLocation } from 'react-router-dom';

 
import ProtectedRoute from './components/auth/ProtectedRoute';
// eslint-disable-next-line import/order
import { Layout } from './components/layout/Layout';

// Pages

import AdminDashboardPage from './pages/admin/AdminDashboardPage';
import AdminMenuPage from './pages/admin/AdminMenuPage';
import OrderDetailsPage from './pages/admin/orders/OrderDetailsPage';
import OrdersListPage from './pages/admin/orders/OrdersListPage';
import PaymentMethodsPage from './pages/admin/settings/PaymentMethodsPage';
import AddProviderConfigPage from './pages/admin/provider-configs/AddProviderConfigPage';
import ProviderConfigDetailsPage from './pages/admin/provider-configs/ProviderConfigDetailsPage';
import ProviderConfigsListPage from './pages/admin/provider-configs/ProviderConfigsListPage';
import SettingsPage from './pages/admin/settings/SettingsPage';
import TransactionDetailsPage from './pages/admin/transactions/TransactionDetailsPage';
import TransactionsListPage from './pages/admin/transactions/TransactionsListPage';
import UserDetailsPage from './pages/admin/users/UserDetailsPage';
import UsersListPage from './pages/admin/users/UsersListPage';
import ManualServicesListPage from './pages/admin/manual-services/ManualServicesListPage';
import AddManualServicePage from './pages/admin/manual-services/AddManualServicePage';
import ManualServiceDetailsPage from './pages/admin/manual-services/ManualServiceDetailsPage';
import AuditLogsListPage from './pages/admin/audit-logs/AuditLogsListPage';
import UserAuditLogsPage from './pages/admin/audit-logs/UserAuditLogsPage';
import AuditLogDetailsPage from './pages/admin/audit-logs/AuditLogDetailsPage';
import ProfitsPage from './pages/admin/profits/ProfitsPage';
import LoginPage from './pages/LoginPage';
import NotFoundPage from './pages/NotFoundPage';

// Import APIs to ensure they're registered
import './store/api/profitsApi';

// Admin Pages

// Protected Route Component

function RootRedirect() {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const tgToken = params.get('tg_token');

  if (tgToken) {
    return <Navigate to={`/login?tg_token=${encodeURIComponent(tgToken)}`} replace />;
  }

  return <Navigate to="/admin/dashboard" replace />;
}

function App() {
  return (
    <Layout>
      <Routes>
        {/* Public Routes */}
        <Route path="/login" element={<LoginPage />} />

        {/* Protected Admin Routes */}
        <Route
          path="/admin"
          element={
            <ProtectedRoute requireAdmin>
              <AdminMenuPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/menu"
          element={
            <ProtectedRoute requireAdmin>
              <AdminMenuPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/dashboard"
          element={
            <ProtectedRoute requireAdmin>
              <AdminDashboardPage />
            </ProtectedRoute>
          }
        />

        {/* Users Management */}
        <Route
          path="/admin/users"
          element={
            <ProtectedRoute requireAdmin>
              <UsersListPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/users/:id"
          element={
            <ProtectedRoute requireAdmin>
              <UserDetailsPage />
            </ProtectedRoute>
          }
        />

        {/* Orders Management */}
        <Route
          path="/admin/orders"
          element={
            <ProtectedRoute requireAdmin>
              <OrdersListPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/orders/:id"
          element={
            <ProtectedRoute requireAdmin>
              <OrderDetailsPage />
            </ProtectedRoute>
          }
        />

        {/* Transactions Management */}
        <Route
          path="/admin/transactions"
          element={
            <ProtectedRoute requireAdmin>
              <TransactionsListPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/transactions/:id"
          element={
            <ProtectedRoute requireAdmin>
              <TransactionDetailsPage />
            </ProtectedRoute>
          }
        />

        {/* Audit Logs Management */}
        <Route
          path="/admin/audit-logs"
          element={
            <ProtectedRoute requireAdmin>
              <AuditLogsListPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/audit-logs/log/:id"
          element={
            <ProtectedRoute requireAdmin>
              <AuditLogDetailsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/audit-logs/:actorId"
          element={
            <ProtectedRoute requireAdmin>
              <UserAuditLogsPage />
            </ProtectedRoute>
          }
        />

        {/* Settings */}
        <Route
          path="/admin/settings"
          element={
            <ProtectedRoute requireAdmin>
              <SettingsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/settings/payments"
          element={
            <ProtectedRoute requireAdmin>
              <PaymentMethodsPage />
            </ProtectedRoute>
          }
        />

        {/* Profits */}
        <Route
          path="/admin/profits"
          element={
            <ProtectedRoute requireAdmin>
              <ProfitsPage />
            </ProtectedRoute>
          }
        />

        {/* Provider Configs */}
        <Route
          path="/admin/provider-configs"
          element={
            <ProtectedRoute requireAdmin>
              <ProviderConfigsListPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/provider-configs/new"
          element={
            <ProtectedRoute requireAdmin>
              <AddProviderConfigPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/provider-configs/:providerId"
          element={
            <ProtectedRoute requireAdmin>
              <ProviderConfigDetailsPage />
            </ProtectedRoute>
          }
        />

        {/* Manual Services */}
        <Route
          path="/admin/manual-services"
          element={
            <ProtectedRoute requireAdmin>
              <ManualServicesListPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/manual-services/new"
          element={
            <ProtectedRoute requireAdmin>
              <AddManualServicePage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/manual-services/:key"
          element={
            <ProtectedRoute requireAdmin>
              <ManualServiceDetailsPage />
            </ProtectedRoute>
          }
        />

        {/* Default Routes */}
        <Route path="/" element={<RootRedirect />} />
        <Route path="/dashboard" element={<RootRedirect />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </Layout>
  );
}

export default App;

